import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from "firebase/database";
import './Footer.css';

// Key for storing the last update timestamp in localStorage
const LAST_UPDATE_DISPLAY_KEY = 'trump_presidency_last_update_display';
const FIREBASE_LAST_UPDATE_PATH = 'meta/lastUpdate';

function Footer() {
  const [lastUpdated, setLastUpdated] = useState('');

  useEffect(() => {
    // Set up Firebase listener for the last update time
    const database = getDatabase();
    const lastUpdateRef = ref(database, FIREBASE_LAST_UPDATE_PATH);
    
    // Listen for changes to the last update time in Firebase
    const unsubscribe = onValue(lastUpdateRef, (snapshot) => {
      const data = snapshot.val();
      if (data && data.formatted) {
        setLastUpdated(data.formatted);
        // Also update localStorage for backwards compatibility
        localStorage.setItem(LAST_UPDATE_DISPLAY_KEY, data.formatted);
      } else {
        // Fallback to localStorage if Firebase data doesn't exist
        const storedUpdateTime = localStorage.getItem(LAST_UPDATE_DISPLAY_KEY);
        if (storedUpdateTime) {
          setLastUpdated(storedUpdateTime);
        } else {
          setLastUpdated('May 17, 2025'); // Default fallback
        }
      }
    }, (error) => {
      console.error("Error getting last update time:", error);
      // Fallback to localStorage on error
      const storedUpdateTime = localStorage.getItem(LAST_UPDATE_DISPLAY_KEY);
      if (storedUpdateTime) {
        setLastUpdated(storedUpdateTime);
      } else {
        setLastUpdated('May 17, 2025'); // Default fallback
      }
    });

    // Cleanup listener on unmount
    return () => unsubscribe();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-stars">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="footer-star"></div>
          ))}
        </div>
        <p>© {new Date().getFullYear()} TRUMP PRESIDENCY TIMELINE TRACKER</p>
        <p>MAKING AMERICA GREAT AGAIN - ONE DAY AT A TIME</p>
        <p>Last updated: {lastUpdated}</p>
        <p className="creator-credit">
          Created by <a href="https://anthonyduncalf.dev" target="_blank" rel="noopener noreferrer">Anthony Duncalf</a>
        </p>
        <div className="footer-stars">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="footer-star"></div>
          ))}
        </div>
      </div>
      <div className="flag-stripe-container footer-stripes">
        <div className="flag-stripe red"></div>
        <div className="flag-stripe white"></div>
        <div className="flag-stripe blue"></div>
      </div>
    </footer>
  );
}

export default Footer;